import { render, staticRenderFns } from "./PurchaseTotal.vue?vue&type=template&id=58b62517&scoped=true&"
import script from "./PurchaseTotal.vue?vue&type=script&lang=js&"
export * from "./PurchaseTotal.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseTotal.vue?vue&type=style&index=0&id=58b62517&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b62517",
  null
  
)

export default component.exports